export default __webpack_public_path__ + "static/media/trash_outline.64bdcb75.svg";